import React from 'react';
import LoadingScreen from 'components/loading_screen/LoadingScreen';

export default function CustomerPortalPanelState({ title, message, status = 'loading' }) {
    if (status === 'loading') {
        return (
            <LoadingScreen
                mode="panel"
                title={title}
                message={message}
            />
        );
    }

    return (
        <div
            className={`customer-portal-panel-state ${status}`}
            role="alert"
            aria-live="polite"
        >
            <h2>{title}</h2>
            <p>{message}</p>
        </div>
    );
}
